new Vue({
    el:'.triFusionActivity',
    data(){
        return{
            // 加载完成
            loadFlag:false,
            // 发送验证码标识
            sendFlag:false,
            loginFlag:false,
            popup:false,
            chancePopup:false,
            pointsPopup:false,
            addressPopup:false,
            loginPopup:false,
            isSend:false,
            isLogin:false,
            sendText:'Send code',
            user:{
                name:'',
                email:'',
                code:'',
                country:'Country'
            },
            address:{
                state:'',
                city:'',
                street:'',
                postal:'',
                phone:'',
                prize:''
            },
            submitFlag:false,
            popup1:false,
            select_flag1:0,
            countryArr:[{country:"Brazil"},{country:"Paraguay"}],
            pointsLog:[],
            prizeNum:[{num:340},{num:230},{num:130},{num:130}],
            prizeIndex:-1,
            emailStr:'',
            add_points:''
        }
    },
    methods:{
        // 功能类------------------------------------------------
        async addPoints(){
            if(this.user.email == 'aliciachen965@gmail.com' || this.user.email == 'timo.luren2@gmail.com' || this.user.email == 'lyn@oxbar.com'){
                if(this.add_points == '' || this.emailStr == ''){
                    showMessage('Please fill in the information completely','error')
                    return;
                }
                var emailArr = this.emailStr.split('\n')
                var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,flag=true
                for(let i=0;i<emailArr.length;i++){
                    if(!emailReg.test(emailArr[i])){
                        flag=false
                    }
                }
                if(flag){
                    if(this.submitFlag) return;
                    this.submitFlag = true
    
                    showMessage('Submitted successfully','success')
                    var resultString = emailArr.map(email => `'${email}'`).join(',');
                    var params=new URLSearchParams();
                    params.append('info',JSON.stringify({str:resultString,add_points:this.add_points}));
                    let res = await axios.post('https://service.oxvatech.cn/trifusion/addPoints',params, {
                        headers: { Authorization: `${this.user.token}`}
                    });
                    if(res.data.status == 200){
                        this.submitFlag = false
                        this.emailStr = ''
                        this.add_points = ''
                    }else{
                        this.submitFlag = false
                        showMessage('Error','error')
                    }
                     
                }else{
                    showMessage('Email format error','error')
                }
            };
        },
        async submitAddress(){
            if(!this.address.state || !this.address.city || !this.address.street || !this.address.postal || !this.address.phone){
                showMessage('Please fill in the information completely','error')
                return;
            } 
            //避免重复提交 
            if(this.submitFlag) return;
            //showMessage('Enviando, aguarde...','success')
            this.submitFlag = true
            this.address.name = this.user.name
            this.address.email = this.user.email
            this.address.country = this.user.country
            this.address.index = this.prizeIndex

            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.address));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/submitAddress',params, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                this.submitFlag = false
                showMessage('Envio realizado com sucesso!','success')
                this.popup = this.addressPopup = false
                this.prizeNum[this.prizeIndex].num -= 1
                this.getInfo()
            }else{
                this.submitFlag = false
                let errorMessages = {
                    201: 'Ops, não tenho pontos suficientes.',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async sendEmail(){
            if(this.user.email == ''){
                showMessage('Please enter your email','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            if(this.sendFlag){
                showMessage('Sent, please try again in one minute.','success')
                setTimeout(() => {
                    this.sendFlag = false
                    this.sendText = 'Send code'
                }, 1000*60);
                return;
            }
            this.sendText = 'Has sent'
            this.sendFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/sendEmail',params);
            if(res.data.status == 200){
                this.isSend = true
                showMessage('Email has been sent, please check.','success')
            }else{
                showMessage('Server error, please contact customer service','error')
            }
        },
        async loginActivity(){
            if(!this.isSend){
                showMessage('Please send the email verification code first','error')
                return;
            } 
            if(!this.user.name || !this.user.email || this.user.country == 'Country' || !this.user.code){
                showMessage('Please fill in the information completely','error')
                return;
            }
            // 邮箱正则表达式
            var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
            if(!emailReg.test(this.user.email)){
                showMessage('Email format error','error')
                return;
            }
            //避免重复提交 
            if(this.loginFlag) return;
            this.loginFlag = true
            var params=new URLSearchParams();
            params.append('info',JSON.stringify(this.user));
            let res = await axios.post('https://service.oxvatech.cn/trifusion/loginActivity',params);
            if(res.data.status == 200){
                this.setCookie('_trifusion_',res.data.data,90)
                this.user.token = res.data.data
                showMessage('Registration successful! ','success')
                this.popup = this.loginPopup = false
                this.getInfo()
            }else{
                this.loginFlag = false
                let errorMessages = {
                    201: 'Email verification code error',
                    202: 'Username already exists',
                    500:' Server error, please contact customer service',
                };
                showMessage(errorMessages[res.data.status] || 'Unknown error', 'error');
            }
        },
        async getInfo(){
            let res = await axios.post('https://service.oxvatech.cn/trifusion/getInfo', {}, {
                headers: { Authorization: `${this.user.token}`}
            });
            if(res.data.status == 200){
                if(res.data.data.arr1.length>0){
                    this.isLogin = true
                    this.user = res.data.data.arr1[0]
                    //积分记录
                    this.pointsLog = res.data.data.arr2
                    
                }else{
                    this.isLogin = false
                }
            }else{
                showMessage('server error','error')
            }
        },
        async getPrizeNum(){
            let res = await axios.get('https://service.oxvatech.cn/trifusion/getPrizeNum')
            if(res.status == 200){
                this.prizeNum = res.data.data
            }
        },
        // 控件类-------------------------------------------------
        toForm(){
            if(!this.checkLogin()) return;
            window.open('https://docs.google.com/forms/d/e/1FAIpQLSf55LcDNh4um6C4eXENEYKmc5XK4Zy3J0kh6E5rFbyh6LJP5w/viewform','_blank')
        },
        redeemPrize(id){
            if(!this.checkLogin()) return;
            this.prizeIndex = id
            var numArr = [20,30,40,50]
            var prizeArr = ['Chinelos','Óculos de Sol','Chapéu Bucket','Garrafa Térmica']
            if(this.user.points < numArr[id]){
                showMessage('Ops, não tenho pontos suficientes.','error')
                return;
            }
            this.address.prize = prizeArr[id]
            this.popup = this.addressPopup = true
        },
        showPopup(type){
            if(!this.checkLogin()) return;
            this.popup = this[type] = true;
        },
        checkLogin(){
            if(!this.isLogin){
                this.popup = this.loginPopup = true;
                return false;
            }
            return true;
            // showMessage('The event has ended, thank you for your participation','success');
            // return false
        },
        emailUpdate(){
            if(this.isSend){
                this.isSend = false
                this.sendFlag = false
                this.sendText = 'Send code'
            }
        },
        // 工具类-------------------------------------------------
        formatISOToDateTime(isoString) {
            var date = new Date(isoString);
          
            // 转为北京时间（+8小时）
            date.setHours(date.getHours());
          
            var pad = (n) => n.toString().padStart(2, '0');
            var year = date.getFullYear();
            var month = pad(date.getMonth() + 1);
            var day = pad(date.getDate());
            var hours = pad(date.getHours());
            var minutes = pad(date.getMinutes());
            var seconds = pad(date.getSeconds());
          
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        setCookie(name,value,day){
            var d = new Date();
            d.setTime(d.getTime() + (day * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = name + "=" + value + ";" + expires + ";path=/";
        },
        getCookie(name){
            var name = name + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var cookieArray = decodedCookie.split(';');
            for(let i = 0; i < cookieArray.length; i++) {
                let cookie = cookieArray[i];
                while (cookie.charAt(0) == ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(name) == 0) {
                    return cookie.substring(name.length, cookie.length);
                }
            }
            return "";
        }
    },
    created(){
        // 加载完成后 更新弹窗显示样式
        this.loadFlag = true
        if(this.getCookie('_trifusion_')){
            this.isLogin = true
            this.user.token = this.getCookie('_trifusion_')
            this.getInfo()
        }
        this.getPrizeNum()
    },
    mounted(){
        var wFlag=true
        if(window.innerWidth<750){
            wFlag=false
        }

        function showUp(dom){
            gsap.from(dom,{
                y:'2rem',opacity:0,ease:'none',duration:0.5,
                scrollTrigger:{
                    trigger:dom,
                    start:'top bottom-=20%',
                    end:'+=0',
                    toggleActions:'play none none reverse',
                }
            })
        }
        setTimeout(() => {
            $('.box1_title').addClass('showup')
            $('.box1_text').addClass('showup')
        }, 500);
    
        showUp('.box2_title')
        ScrollTrigger.create({
            trigger:'.box2',
            start:'top top+=30%',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box2_item img',{x:'-100%',opacity:0})
                .from('.box2_item div:nth-child(3)',{x:'140%',opacity:0},'<')
                .from('.box2_item div:nth-child(2)',{opacity:0})
        })
    
        showUp('.box3_title')
        ScrollTrigger.create({
            trigger:'.box3',
            start:wFlag?'top top+=30%':'top center',
            end:'+=0%',
            toggleActions:'play none none reverse',
            animation:gsap.timeline()
                .from('.box3_item',{y:'2rem',opacity:0,stagger:0.2})
        })
    }
})